export const LANGS = [
  { code: 'ca', label: 'CA' },
  { code: 'es', label: 'ES' },
  { code: 'fr', label: 'FR' },
];

export const translations = {
  ca: {
    nav: { entorn: "L'Entorn", mapa: 'Mapa', agenda: 'Agenda', contacte: 'Contacte', previous: 'Edicions anteriors', download: "Descarrega't el programa" },
    intro: {
      p1: "Canillo Escènic Arts és el primer festival d'arts escèniques del Principat. Neix amb la voluntat de difondre, promoure, impulsar i desenvolupar la indústria de les arts escèniques al País.",
      p2: "Canillo Escènic Arts també vol servir d'aparador per a artistes locals i internacionals, i pretén acostar al públic un ampli ventall de propostes creatives, originals i innovadores vinculades a les arts escèniques.",
    },
    hero: {
      edition: 'CANILLO ESCÈNIC ARTS 2026',
      slogan: 'ENCENEM LA IMAGINACIÓ',
      place: 'Canillo · Andorra',
      free: 'Tots els espectacles gratuïts',
      ctaAgenda: "Veure l'agenda",
      ctaMapa: 'Localitzacions',
      exploreBtn: 'Explorar Programació',
    },
    entorn: {
      tag: "L'ENTORN",
      title: 'Un festival a cel obert al cor dels Pirineus',
      p1: "Canillo es transforma en un escenari natural on la llum, el moviment i la imaginació prenen els carrers, les places i els paisatges. Durant nou nits, el poble s'omple d'arts escèniques de carrer arribades d'arreu del món.",
      p2: "La instal·lació lumínica «Lampounette» de la companyia francesa TILT il·lumina el Passeig del Riu amb gegantines làmpades de taula, convidant a passejar entre la realitat i el somni.",
      chips: ['Entrada gratuïta', 'Per a tots els públics'],
      installTitle: 'Instal·lacions & exposició',
      visitBtn: 'Visita Canillo',
    },
    mapa: {
      tag: 'LOCALITZACIONS',
      title: 'On passa la màgia',
      subtitle: 'Selecciona una localització per descobrir quins espectacles gratuïts s\'hi celebren.',
      all: 'Totes',
      showsHere: 'Espectacles en aquesta localització',
      none: "No hi ha espectacles assignats a aquesta localització.",
      openMap: 'Obrir a Google Maps',
    },
    edicions: {
      tag: 'EDICIONS ANTERIORS',
      title: 'El que ja ha passat',
      subtitle: "Cada edició té la seva pròpia pàgina a l'arxiu del festival.",
      archive: 'Arxiu',
      program: 'El programa',
    },
    edicio: {
      title: 'Edició 2026',
      subtitle: "Tots els espectacles i les instal·lacions de l'edició.",
      count: 'propostes',
      back: 'Tornar a la portada',
    },
    agenda: {
      tag: 'AGENDA',
      title: 'Programació 2026',
      subtitle: 'Cerca i filtra entre tots els espectacles i instal·lacions del festival.',
      search: 'Cerca per títol, companyia o disciplina…',
      allDates: 'Tots',
      disciplineLabel: 'Disciplina',
      allDisciplines: 'Totes',
      typeAll: 'Tot',
      typeShows: 'Espectacles',
      typeInstall: 'Instal·lacions',
      details: 'Veure detalls',
      results: 'resultats',
      noResults: 'No hem trobat cap proposta amb aquests filtres.',
      clear: 'Netejar filtres',
      free: 'Gratuït',
      installation: 'Instal·lació',
      daily: 'Cada dia',
    },
    modal: { company: 'Companyia', country: 'País', date: 'Data', time: 'Hora', discipline: 'Disciplina', audience: 'Públic', venue: 'Localització', synopsis: 'Sinopsi', close: 'Tancar', dates: 'Dates' },
    avis: { badge: 'CANCEL·LAT', heading: 'Avís important', cancelled: 'Espectacle cancel·lat' },
    contact: {
      tag: 'CONTACTE',
      title: 'Parlem',
      subtitle: 'Per a artistes, premsa o públic general. Escriu-nos i et respondrem.',
      name: 'Nom', email: 'Correu electrònic', subject: 'Assumpte', message: 'Missatge',
      send: 'Enviar missatge', sending: 'Enviant…',
      success: 'Gràcies! Hem rebut el teu missatge correctament.',
      successSub: 'Et respondrem el més aviat possible.',
      error: 'Hi ha hagut un error. Torna-ho a provar.',
      required: 'Aquest camp és obligatori', invalidEmail: 'Correu electrònic no vàlid',
      another: 'Enviar un altre missatge',
      infoTitle: 'Informació', infoPlace: 'Canillo, Andorra', infoFree: 'Tots els espectacles són gratuïts',
    },
    footer: { rights: 'Tots els drets reservats', org: 'Organitza: Comú de Canillo', tagline: 'Encenem la imaginació', menu: 'Navegació', legalTitle: 'Legal', legal: 'Avís legal', privacy: 'Política de privacitat', cookies: 'Cookies', contact: 'Contacte' },
    sponsors: { title: 'Amb el suport de' },
    months: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
    admin: {
      title: 'Panell Administració', subtitle: 'Missatges de contacte', password: 'Contrasenya', login: 'Entrar', logout: 'Sortir',
      wrong: 'Contrasenya incorrecta', loading: 'Carregant…', empty: 'Encara no hi ha missatges.',
      colDate: 'Data', colName: 'Nom', colEmail: 'Correu', colSubject: 'Assumpte', colMessage: 'Missatge', total: 'missatges',
    },
    legalNotice: {
      title: 'Avís legal',
      updated: 'Última actualització: gener de 2026',
      sections: [
        { h: '1. Dades identificatives', p: "En compliment de la normativa vigent, s'informa que aquest lloc web és titularitat del Comú de Canillo, amb domicili a Canillo (Principat d'Andorra). Per a qualsevol consulta podeu contactar a través del formulari de contacte d'aquest mateix web." },
        { h: '2. Objecte', p: 'Aquest lloc web té com a finalitat informar sobre el festival Canillo Escènic Arts, la seva programació, localitzacions i activitats. Tots els espectacles del festival són gratuïts.' },
        { h: '3. Propietat intel·lectual', p: "Tots els continguts (textos, imatges, logotips, dissenys i codi font) estan protegits pels drets de propietat intel·lectual i industrial. Queda prohibida la seva reproducció, distribució, comunicació pública o transformació sense l'autorització expressa del titular." },
        { h: '4. Responsabilitat', p: "El titular no es fa responsable de l'ús indegut dels continguts ni dels possibles errors o canvis en la programació. Els enllaços a webs de tercers s'ofereixen únicament a títol informatiu, sense que el titular n'assumeixi cap responsabilitat." },
        { h: '5. Legislació aplicable', p: "Aquest avís legal es regeix per la legislació del Principat d'Andorra. Qualsevol controvèrsia se sotmetrà als tribunals competents d'Andorra." },
      ],
    },
  },
  es: {
    nav: { entorn: 'El Entorno', mapa: 'Mapa', agenda: 'Agenda', contacte: 'Contacto', previous: 'Ediciones anteriores', download: 'Descárgate el programa' },
    intro: {
      p1: 'Canillo Escènic Arts es el primer festival de artes escénicas del Principado. Nace con la voluntad de difundir, promover, impulsar y desarrollar la industria de las artes escénicas en el País.',
      p2: 'Canillo Escènic Arts también quiere servir de escaparate para artistas locales e internacionales, y pretende acercar al público un amplio abanico de propuestas creativas, originales e innovadoras vinculadas a las artes escénicas.',
    },
    hero: {
      edition: 'CANILLO ESCÈNIC ARTS 2026',
      slogan: 'ENCENDEMOS LA IMAGINACIÓN',
      place: 'Canillo · Andorra',
      free: 'Todos los espectáculos gratuitos',
      ctaAgenda: 'Ver la agenda',
      ctaMapa: 'Localizaciones',
      exploreBtn: 'Explorar Programación',
    },
    entorn: {
      tag: 'EL ENTORNO',
      title: 'Un festival a cielo abierto en el corazón de los Pirineos',
      p1: 'Canillo se transforma en un escenario natural donde la luz, el movimiento y la imaginación toman las calles, las plazas y los paisajes. Durante nueve noches, el pueblo se llena de artes escénicas de calle llegadas de todo el mundo.',
      p2: 'La instalación lumínica «Lampounette» de la compañía francesa TILT ilumina el Passeig del Riu con gigantescas lámparas de mesa, invitando a pasear entre la realidad y el sueño.',
      chips: ['Entrada gratuita', 'Para todos los públicos'],
      installTitle: 'Instalaciones y exposición',
      visitBtn: 'Visita Canillo',
    },
    mapa: {
      tag: 'LOCALIZACIONES',
      title: 'Donde sucede la magia',
      subtitle: 'Selecciona una localización para descubrir qué espectáculos gratuitos se celebran allí.',
      all: 'Todas',
      showsHere: 'Espectáculos en esta localización',
      none: 'No hay espectáculos asignados a esta localización.',
      openMap: 'Abrir en Google Maps',
    },
    edicions: {
      tag: 'EDICIONES ANTERIORES',
      title: 'Lo que ya ha pasado',
      subtitle: 'Cada edición tiene su propia página en el archivo del festival.',
      archive: 'Archivo',
      program: 'El programa',
    },
    edicio: {
      title: 'Edición 2026',
      subtitle: 'Todos los espectáculos y las instalaciones de la edición.',
      count: 'propuestas',
      back: 'Volver a la portada',
    },
    agenda: {
      tag: 'AGENDA',
      title: 'Programación 2026',
      subtitle: 'Busca y filtra entre todos los espectáculos e instalaciones del festival.',
      search: 'Busca por título, compañía o disciplina…',
      allDates: 'Todos',
      disciplineLabel: 'Disciplina',
      allDisciplines: 'Todas',
      typeAll: 'Todo',
      typeShows: 'Espectáculos',
      typeInstall: 'Instalaciones',
      details: 'Ver detalles',
      results: 'resultados',
      noResults: 'No hemos encontrado ninguna propuesta con estos filtros.',
      clear: 'Limpiar filtros',
      free: 'Gratuito',
      installation: 'Instalación',
      daily: 'Cada día',
    },
    modal: { company: 'Compañía', country: 'País', date: 'Fecha', time: 'Hora', discipline: 'Disciplina', audience: 'Público', venue: 'Localización', synopsis: 'Sinopsis', close: 'Cerrar', dates: 'Fechas' },
    avis: { badge: 'CANCELADO', heading: 'Aviso importante', cancelled: 'Espectáculo cancelado' },
    contact: {
      tag: 'CONTACTO',
      title: 'Hablemos',
      subtitle: 'Para artistas, prensa o público general. Escríbenos y te responderemos.',
      name: 'Nombre', email: 'Correo electrónico', subject: 'Asunto', message: 'Mensaje',
      send: 'Enviar mensaje', sending: 'Enviando…',
      success: '¡Gracias! Hemos recibido tu mensaje correctamente.',
      successSub: 'Te responderemos lo antes posible.',
      error: 'Ha ocurrido un error. Inténtalo de nuevo.',
      required: 'Este campo es obligatorio', invalidEmail: 'Correo electrónico no válido',
      another: 'Enviar otro mensaje',
      infoTitle: 'Información', infoPlace: 'Canillo, Andorra', infoFree: 'Todos los espectáculos son gratuitos',
    },
    footer: { rights: 'Todos los derechos reservados', org: 'Organiza: Comú de Canillo', tagline: 'Encendemos la imaginación', menu: 'Navegación', legalTitle: 'Legal', legal: 'Aviso legal', privacy: 'Política de privacidad', cookies: 'Cookies', contact: 'Contacto' },
    sponsors: { title: 'Con el apoyo de' },
    months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    admin: {
      title: 'Panel Administración', subtitle: 'Mensajes de contacto', password: 'Contraseña', login: 'Entrar', logout: 'Salir',
      wrong: 'Contraseña incorrecta', loading: 'Cargando…', empty: 'Aún no hay mensajes.',
      colDate: 'Fecha', colName: 'Nombre', colEmail: 'Correo', colSubject: 'Asunto', colMessage: 'Mensaje', total: 'mensajes',
    },
    legalNotice: {
      title: 'Aviso legal',
      updated: 'Última actualización: enero de 2026',
      sections: [
        { h: '1. Datos identificativos', p: 'En cumplimiento de la normativa vigente, se informa de que este sitio web es titularidad del Comú de Canillo, con domicilio en Canillo (Principado de Andorra). Para cualquier consulta puede contactar a través del formulario de contacto de esta misma web.' },
        { h: '2. Objeto', p: 'Este sitio web tiene como finalidad informar sobre el festival Canillo Escènic Arts, su programación, localizaciones y actividades. Todos los espectáculos del festival son gratuitos.' },
        { h: '3. Propiedad intelectual', p: 'Todos los contenidos (textos, imágenes, logotipos, diseños y código fuente) están protegidos por los derechos de propiedad intelectual e industrial. Queda prohibida su reproducción, distribución, comunicación pública o transformación sin la autorización expresa del titular.' },
        { h: '4. Responsabilidad', p: 'El titular no se hace responsable del uso indebido de los contenidos ni de los posibles errores o cambios en la programación. Los enlaces a webs de terceros se ofrecen únicamente a título informativo, sin que el titular asuma responsabilidad alguna sobre ellos.' },
        { h: '5. Legislación aplicable', p: 'El presente aviso legal se rige por la legislación del Principado de Andorra. Cualquier controversia se someterá a los tribunales competentes de Andorra.' },
      ],
    },
  },
  fr: {
    nav: { entorn: "L'Environnement", mapa: 'Carte', agenda: 'Programme', contacte: 'Contact', previous: 'Éditions précédentes', download: 'Télécharge le programme' },
    intro: {
      p1: "Canillo Escènic Arts est le premier festival d'arts de la scène de la Principauté. Il naît avec la volonté de diffuser, promouvoir, encourager et développer l'industrie des arts de la scène dans le pays.",
      p2: "Canillo Escènic Arts veut aussi servir de vitrine aux artistes locaux et internationaux, et entend rapprocher du public un large éventail de propositions créatives, originales et innovantes liées aux arts de la scène.",
    },
    hero: {
      edition: 'CANILLO ESCÈNIC ARTS 2026',
      slogan: "ALLUMONS L'IMAGINATION",
      place: 'Canillo · Andorre',
      free: 'Tous les spectacles gratuits',
      ctaAgenda: 'Voir le programme',
      ctaMapa: 'Lieux',
      exploreBtn: 'Explorer le Programme',
    },
    entorn: {
      tag: "L'ENVIRONNEMENT",
      title: 'Un festival à ciel ouvert au cœur des Pyrénées',
      p1: "Canillo se transforme en une scène naturelle où la lumière, le mouvement et l'imagination envahissent les rues, les places et les paysages. Pendant neuf nuits, le village se remplit d'arts de la rue venus du monde entier.",
      p2: "L'installation lumineuse « Lampounette » de la compagnie française TILT illumine le Passeig del Riu avec de gigantesques lampes de bureau, invitant à se promener entre réalité et rêve.",
      chips: ['Entrée gratuite', 'Tout public'],
      installTitle: 'Installations & exposition',
      visitBtn: 'Visite Canillo',
    },
    mapa: {
      tag: 'LIEUX',
      title: 'Là où la magie opère',
      subtitle: 'Sélectionnez un lieu pour découvrir quels spectacles gratuits y sont présentés.',
      all: 'Tous',
      showsHere: 'Spectacles dans ce lieu',
      none: "Aucun spectacle n'est assigné à ce lieu.",
      openMap: 'Ouvrir dans Google Maps',
    },
    edicions: {
      tag: 'ÉDITIONS PRÉCÉDENTES',
      title: "Ce qui s'est déjà passé",
      subtitle: 'Chaque édition a sa propre page dans les archives du festival.',
      archive: 'Archives',
      program: 'Le programme',
    },
    edicio: {
      title: 'Édition 2026',
      subtitle: "Tous les spectacles et les installations de l'édition.",
      count: 'propositions',
      back: "Retour à l'accueil",
    },
    agenda: {
      tag: 'PROGRAMME',
      title: 'Programmation 2026',
      subtitle: 'Recherchez et filtrez parmi tous les spectacles et installations du festival.',
      search: 'Rechercher par titre, compagnie ou discipline…',
      allDates: 'Tous',
      disciplineLabel: 'Discipline',
      allDisciplines: 'Toutes',
      typeAll: 'Tout',
      typeShows: 'Spectacles',
      typeInstall: 'Installations',
      details: 'Voir les détails',
      results: 'résultats',
      noResults: "Aucune proposition trouvée avec ces filtres.",
      clear: 'Effacer les filtres',
      free: 'Gratuit',
      installation: 'Installation',
      daily: 'Chaque jour',
    },
    modal: { company: 'Compagnie', country: 'Pays', date: 'Date', time: 'Heure', discipline: 'Discipline', audience: 'Public', venue: 'Lieu', synopsis: 'Synopsis', close: 'Fermer', dates: 'Dates' },
    avis: { badge: 'ANNULÉ', heading: 'Avis important', cancelled: 'Spectacle annulé' },
    contact: {
      tag: 'CONTACT',
      title: 'Parlons-en',
      subtitle: "Pour les artistes, la presse ou le grand public. Écrivez-nous et nous vous répondrons.",
      name: 'Nom', email: 'E-mail', subject: 'Sujet', message: 'Message',
      send: 'Envoyer le message', sending: 'Envoi…',
      success: 'Merci ! Nous avons bien reçu votre message.',
      successSub: 'Nous vous répondrons dans les plus brefs délais.',
      error: "Une erreur s'est produite. Veuillez réessayer.",
      required: 'Ce champ est obligatoire', invalidEmail: 'E-mail non valide',
      another: 'Envoyer un autre message',
      infoTitle: 'Informations', infoPlace: 'Canillo, Andorre', infoFree: 'Tous les spectacles sont gratuits',
    },
    footer: { rights: 'Tous droits réservés', org: 'Organisé par : Comú de Canillo', tagline: "Allumons l'imagination", menu: 'Navigation', legalTitle: 'Légal', legal: 'Mentions légales', privacy: 'Politique de confidentialité', cookies: 'Cookies', contact: 'Contact' },
    sponsors: { title: 'Avec le soutien de' },
    months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sep', 'Oct', 'Nov', 'Déc'],
    admin: {
      title: 'Panneau Administration', subtitle: 'Messages de contact', password: 'Mot de passe', login: 'Entrer', logout: 'Sortir',
      wrong: 'Mot de passe incorrect', loading: 'Chargement…', empty: 'Aucun message pour le moment.',
      colDate: 'Date', colName: 'Nom', colEmail: 'E-mail', colSubject: 'Sujet', colMessage: 'Message', total: 'messages',
    },
    legalNotice: {
      title: 'Mentions légales',
      updated: 'Dernière mise à jour : janvier 2026',
      sections: [
        { h: '1. Données d’identification', p: "Conformément à la réglementation en vigueur, il est précisé que ce site web appartient au Comú de Canillo, domicilié à Canillo (Principauté d'Andorre). Pour toute question, vous pouvez nous contacter via le formulaire de contact de ce même site." },
        { h: '2. Objet', p: 'Ce site web a pour but d’informer sur le festival Canillo Escènic Arts, sa programmation, ses lieux et ses activités. Tous les spectacles du festival sont gratuits.' },
        { h: '3. Propriété intellectuelle', p: "Tous les contenus (textes, images, logos, designs et code source) sont protégés par les droits de propriété intellectuelle et industrielle. Leur reproduction, distribution, communication publique ou transformation est interdite sans l'autorisation expresse du titulaire." },
        { h: '4. Responsabilité', p: "Le titulaire n'est pas responsable de l'usage abusif des contenus ni des éventuelles erreurs ou modifications de la programmation. Les liens vers des sites tiers sont fournis à titre informatif uniquement, sans que le titulaire en assume la responsabilité." },
        { h: '5. Législation applicable', p: "Les présentes mentions légales sont régies par la législation de la Principauté d'Andorre. Tout litige sera soumis aux tribunaux compétents d'Andorre." },
      ],
    },
  },
};
